export default __webpack_public_path__ + "media/images/preview-967ef3588998f9da9f48922164e1d07d.png";